import TranslatePattern from './TranslatePattern';

export default TranslatePattern;